import { useState, useEffect } from "react";
import NotStartedView from "./NotStartedPage/NotStartedView";
import PreparationPage from "./PreparationPage/PreparationPage";
import { Divider, Stepper, StepLabel, Step } from "@mui/material";
import ResultPage from "./ResultPage/ResultPage";
import { useTranslation } from "react-i18next";
import DashboardView from "./DashboardPage/DashboardView";
import GeneratePDFPage from "./DashboardPage/GeneratePDFPage";
import MeasurementView from "./MeasurementPage/MeasurementView";
import { Project } from "../../types/project";
import { StageView } from "../../types/stageView";
import { Stage } from "../../types/enums";
import { CustomStepConnector, ProjectProgressStepper } from "../Reuseables/CustomStepper";
import GenerateDashboardPowerpointPage from "./DashboardPage/Powerpoint/GenerateDashboardPPTXPopup";


type ProjectOverviewProps = {
  project: Project;
};

export default function ProjectOverview({ project }: ProjectOverviewProps) {
  const [view, setView] = useState<StageView>({
    stage: project.stage,
    props: null,
  });
  const { t } = useTranslation();
  const steps = ["stage.notStarted", "stage.measurement", "stage.result"];

  useEffect(() => {
    setView({ stage: project.stage, props: null });
  }, [project.stage]);

  function _renderProjectView() {
    switch (view.stage) {
      case 0:
        return <PreparationPage project={project} />;
      case 1:
        return <NotStartedView project={project} />;
      case 2:
        return <MeasurementView project={project} setView={setView} />;
      case 3:
        return <ResultPage project={project} />;
      case 8:
        return <DashboardView pc={project.projectCode} setView={setView} />;
      case 9:
        return <GeneratePDFPage props={view.props} />;
      default:
        return <div>Not Found</div>;
    }
  }

  return (
    <>
      {project.stage < Stage.NotStarted ? (
        <Divider />
      ) : (
        <Stepper connector={<CustomStepConnector/>} alternativeLabel activeStep={project.stage-1}>
          {steps.map((label, index) => {
            const labelProps: any = {};
            if (index === 0 && project.stage === Stage.NotStarted) {
              labelProps.error = true;
            }
            return (
              <Step key={label}>
                <StepLabel StepIconComponent={ProjectProgressStepper} {...labelProps}>{t(label)}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
      )}

      {_renderProjectView()}
    </>
  );
}
